import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { keyframes } from 'styled-components';
import { bounceIn } from 'react-animations';

import img5 from "../static/img5.gif";
import BasicBtn from "./structure/BasicBtn";

const bounceInAnimation = keyframes`${bounceIn}`

const BounceInDiv = styled.div`
  animation: 1s ${bounceInAnimation};
`;


const ContentStart = (props) => {
  return (
    <div className="content-start content">
      <a className="close" href="zepeto://WEBVIEW/CLOSE"><FontAwesomeIcon icon="times" /></a>
      <div className="content-start-card">
          <BounceInDiv>
            <div className="content-start-title1"> ZEPETO </div>
            <div className="content-start-title2"> WORLDCUP </div>
          </BounceInDiv>
          <div className="content-start-icon-wrapper">  
            <img className="content-start-icon" src={img5} alt=""/>
          </div>
        
        {/* <PulseDiv> */}
          <BasicBtn text="START" onClick={props.onClick} />
        {/* </PulseDiv> */}
      </div>
    </div>
  );
}
export default ContentStart;